<header id="page-topbar">
  <div class="layout-width">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box horizontal-logo">
          <a href="index.html" class="logo logo-dark">
                        <span class="logo-sm">
<!--                            <img src="assets/images/logo-sm.png" alt="" height="22">-->
                        </span>
            <span class="logo-lg">
<!--                            <img src="assets/images/logo-dark.png" alt="" height="17">-->
                        </span>
          </a>

          <a href="index.html" class="logo logo-light">
                        <span class="logo-sm">
<!--                            <img src="assets/images/logo-sm.png" alt="" height="22">-->
                        </span>
            <span class="logo-lg">
<!--                            <img src="assets/images/logo-light.png" alt="" height="17">-->
                        </span>
          </a>
        </div>

        <button type="button" class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                id="topnav-hamburger-icon">
                    <span class="hamburger-icon">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
        </button>

        <!-- App Search-->

      </div>

      <div class="d-flex align-items-center">
        <div class="dropdown ms-sm-3 header-item topbar-user">
          <button type="button" class="btn" id="page-header-user-dropdown" data-bs-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                        <span class="d-flex align-items-center">
                           <img class="rounded-circle header-profile-user" src="assets/images/users/user-dummy-img.jpg" alt="Header Avatar">
                            <span class="text-start ms-xl-2">
                                <span class="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{{username}}</span>
                                <span class="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text"></span>
                            </span>
                        </span>
          </button>
          <div class="dropdown-menu dropdown-menu-end">
            <!-- item-->
            <h6 class="dropdown-header">Welcome {{username}}!</h6>
            <a class="dropdown-item" href="pages-profile.html"><i
              class="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i> <span
              class="align-middle">Profile</span></a>
            <a class="dropdown-item" href="auth-logout-basic.html"><i
              class="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
              <span
              class="align-middle" data-key="t-logout">Logout</span></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
<!-- ========== App Menu ========== -->
<div class="app-menu navbar-menu">
  <!-- LOGO -->
 <div style="font-size: 16px; color: white; margin-left: 10%; margin-top: 20px">
  <img src="assets/images/newton-logo.png" alt="" width="150">
 </div>

  <div id="scrollbar">
    <div class="container-fluid">

      <div id="two-column-menu">
      </div>
      <ul class="navbar-nav" id="navbar-nav">
        <li class="menu-title"><i class="ri-more-fill"></i> <span data-key="t-pages"></span></li>
        <li class="menu-title"><span data-key="t-menu">Menu</span></li>
        <li class="nav-item">
          <a class="nav-link menu-link" [routerLink]="['/']">
            <i class="ri-account-circle-line"></i> <span data-key="t-landing">Dashboard</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link menu-link" [routerLink]="['/system-user/list']">
            <i class="ri-account-circle-line"></i> <span data-key="t-landing">System Users</span>
          </a>
        </li>

      </ul>
    </div>
    <!-- Sidebar -->
  </div>
</div>
<!-- Left Sidebar End -->
<!-- Vertical Overlay-->
<div class="vertical-overlay"></div>
<div class="main-content">
  <div class="page-content">
    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6">
        <script>document.write(new Date().getFullYear())</script> © Newton iEstate
      </div>
      <div class="col-sm-6">
        <div class="text-sm-end d-none d-sm-block">
        </div>
      </div>
    </div>
  </div>
</footer>
